import pick from "reassemble/cjs/utils/pick";

export { pick };
export default pick;
